export default __webpack_public_path__ + "static/media/ic_arrow_right_black.6c0b554d.svg";